/**
 * How wide the widget is allowed to grow, stored per premise in RDS's
 * `app_settings.gp_widget.max_width` (the same place `hours`/`css`/`features` live). A pixel
 * number, a CSS length string, or the literal `"none"` (fill the container completely).
 * Missing or invalid values fall back to the widget's built-in 420px default, which is why this
 * returns `null` rather than that default itself — the caller decides what "unset" means.
 * Overridable per embed with `data-max-width`, using this same validation.
 */
export function parseMaxWidth(value: unknown): string | null {
  if (typeof value === "number") return Number.isFinite(value) && value > 0 ? `${value}px` : null;
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (trimmed === "none") return "none";
  if (/^\d+(\.\d+)?$/.test(trimmed)) return `${trimmed}px`;
  if (/^\d+(\.\d+)?(px|rem|em|ch|%|vw)$/.test(trimmed)) return trimmed;
  return null;
}
